import { render, staticRenderFns } from "./WidgetsDialogs.vue?vue&type=template&id=142265fc&scoped=true"
import script from "./WidgetsDialogs.vue?vue&type=script&lang=js"
export * from "./WidgetsDialogs.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDialogs.vue?vue&type=style&index=0&id=142265fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142265fc",
  null
  
)

export default component.exports